module.exports = __webpack_public_path__ + "img/user-guide-flow-diagram.ko.5003d4ab.png";